export default function Python_For_Loops() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_For_Loops</h1>
      <p>Content for Python_For_Loops goes here.</p>
    </div>
  );
}